(() => {
  const section=document.querySelector('[data-ceika-wheels-preview]');
  const root=section?.querySelector('ceika-native-configurator');
  if(!root)return;
  const button=section.querySelector('[data-wheel-cart-add]'),status=section.querySelector('[data-wheel-cart-status]');
  // Release 2 is a quote-only preview. There is no cart mutation path.
  button.disabled=true;
  button.addEventListener('click',()=>{if(button.dataset.r2PurchaseReady==='true')return;button.disabled=true;status.textContent='Preview only · purchasing is disabled.';});
  const route=window.Shopify?.routes?.root||'/';
  async function request(path,body){
    if(body)throw Error('Purchasing is disabled in this preview.');
    if(!/^\/(?:[a-z0-9-]+\/)*$/i.test(route)||!/^(?:cart\.js|variants\/\d+\.js)$/.test(path))throw Error('Invalid preview price request');
    const response=await fetch(route+path,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(20000)});
    if(!response.ok)throw Error('Option prices could not be verified. Refresh the preview.');
    return response.json();
  }
  async function init(){
    if(String(window.Shopify?.theme?.id)!=='189771874532'||!['unpublished','main'].includes(window.Shopify?.theme?.role))throw Error('Open the approved CEIKA release theme to view this configuration.');
    const source=window.CeikaWheelFamilyCatalog;
    if(!source||String(section.dataset.productId)!==source.productId)throw Error('This wheel product is not connected to the preview.');
    const catalog=structuredClone(source);
    const controls=JSON.parse(section.querySelector('[data-wheel-option-controls]')?.textContent||'null');
    if(controls){
      if(controls.schemaVersion!==1||controls.family!=='wheels'||String(controls.productId)!==catalog.productId||controls.sourceProfileHash!==catalog.sourceProfileHash||!Array.isArray(controls.disabledOptionKeys))throw Error('Wheel option settings need review.');
      for(const key of controls.disabledOptionKeys){
        const rule=Object.values(catalog.managerControls).find(r=>r.key===key),option=catalog.options.find(o=>o.key===key),value=option?.values.find(v=>v.key===rule?.fallback);
        if(!value||value.price!==0||value.chargeVariantId)throw Error('Wheel option settings need review.');
        option.values=[value];
        const group=root.querySelector(`[data-group="${key}"]`);group?.querySelector('[data-value="Not added"]')?.click();
        if(group){group.hidden=true;group.querySelectorAll('button').forEach(b=>b.disabled=true);}
      }
    }
    const before=await request('cart.js'),country=window.Shopify.country;
    const ids=[...new Set([catalog.priceVariantId,...catalog.options.flatMap(o=>o.values.map(v=>v.chargeVariantId).filter(Boolean))])];
    const prices={},queue=[...ids];
    // Bound concurrency leaves room for product photographs on mobile connections.
    await Promise.all(Array.from({length:6},async()=>{while(queue.length){const id=queue.shift(),v=await request('variants/'+id+'.js');if(String(v.id)!==id||!Number.isSafeInteger(v.price)||v.price<0)throw Error('Option prices could not be verified.');prices[id]={price:v.price,currency:before.currency,available:v.available===true};}}));
    if((await request('cart.js')).currency!==before.currency||window.Shopify.country!==country)throw Error('Your market changed. Refresh the preview.');
    window.CeikaWheelMarket={currency:before.currency,prices,catalog};
    root.dataset.priceVerification='verified';
    status.textContent='Market prices verified · preview only · purchasing disabled.';
    root.dispatchEvent(new Event('ceika:request-total'));
  }
  init().catch(error=>{button.disabled=true;root.dataset.priceVerification='failed';status.textContent=error.message;});
})();

